var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-grow-1 text-right",staticStyle:{"flex-basis":"0"}},[_vm._v(" "+_vm._s(_vm.data.value.toLocaleString('hun', {minimumFractionDigits: 2, maximumFractionDigits: 2}))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }